'use strict';

export const nocConfig = /*@ngInject*/ ["$httpProvider", "$translateProvider", "markedProvider", "tmhDynamicLocaleProvider", function nocConfig($httpProvider, $translateProvider,  markedProvider, tmhDynamicLocaleProvider) {
    // load the json translation files
    $translateProvider.useStaticFilesLoader({
        prefix: 'assets/i18n/',
        suffix: '.json'
    });
    // always define fallback language before preferred language, so don't change this order
    $translateProvider.fallbackLanguage('en');
    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');



    $httpProvider.interceptors.push('NocHttpInterceptor');
    $httpProvider.interceptors.push('XSRFInterceptor');

    markedProvider.setOptions({gfm: true});

    tmhDynamicLocaleProvider.localeLocationPattern('angular-i18n/angular-locale_{{locale}}.js');
}];

